import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

export { ToggleSetButton }

const labels: Record<
  Props['type'],
  {
    empty: string
    showAll: string
    showActive: string
  }
> = {
  bijlagen: {
    empty: 'Geen geannuleerde bijlagen',
    showAll: 'Toon ook geannuleerde bijlagen',
    showActive: 'Toon alleen actieve bijlagen',
  },
  contactpersonen: {
    empty: 'Geen verwijderde contactpersonen',
    showAll: 'Toon ook verwijderde contactpersonen',
    showActive: 'Toon alleen actieve contactpersonen',
  },
  subprocessen: {
    empty: 'Geen verwijderde subprocessen',
    showAll: 'Toon ook verwijderde subprocessen',
    showActive: 'Toon alleen actieve subprocessen',
  },
  activiteiten: {
    empty: 'Geen afgehandelde activiteiten',
    showAll: 'Toon ook afgehandelde activiteiten',
    showActive: 'Toon alleen open activiteiten',
  },
} as const

type Props = {
  active: boolean
  onClick: () => void
  toggledSetSize: number
  type: 'bijlagen' | 'contactpersonen' | 'subprocessen' | 'activiteiten'
}

const ToggleSetButton = ({ active, onClick, toggledSetSize, type }: Props) => {
  const title = !toggledSetSize
    ? labels[type].empty
    : toggledSetSize && !active
      ? labels[type].showAll + ` (${toggledSetSize})`
      : labels[type].showActive

  const clickHandler = () => {
    if (toggledSetSize) {
      onClick()
    }
  }

  return (
    <Tooltip title={title}>
      <Badge
        badgeContent={active ? undefined : toggledSetSize}
        onClick={clickHandler}
        sx={{
          cursor: 'pointer',

          '& .MuiBadge-badge': {
            top: '5px',
            right: '5px',
            backgroundColor: 'secondary.main',
            color: 'white',
          },
        }}
      >
        <IconButton
          disabled={!toggledSetSize}
          onClick={clickHandler}
          sx={{ height: '40px', width: '40px' }}
        >
          {active ? <LibraryBooksIcon /> : <LibraryAddCheckIcon />}
        </IconButton>
      </Badge>
    </Tooltip>
  )
}
